import React from 'react'
import useTrans from '@hooks/useTrans'
import { cn } from '@utils/safeTs'
import { ArrowLeft, Bin, Edit, Plus } from '@components/icons'
import { Button } from '@components/atoms'
import { EditorStatusType } from '@utils/types'
import styles from './EditorHead.module.sass'

interface Props {
  status?: EditorStatusType
  posizioneId?: number
  setPosizioneId?: (p: number) => void
  previewMode?: boolean
  onTecnicaEdit?: () => void
  onArticoloPrincipaleEdit?: () => void
  onPosizioneAdd?: () => void
  onPosizioneRemove?: (p: number) => void
  onCloseEditor?: () => void
  className?: string
}

const EditorHead = (props: Props) => {
  const {
    status,
    posizioneId,
    setPosizioneId,
    previewMode = false,
    onTecnicaEdit,
    onArticoloPrincipaleEdit,
    onPosizioneAdd,
    onPosizioneRemove,
    onCloseEditor,
    className = '',
  } = props

  const t = useTrans()

  const details = [
    {
      key: 'tecnica',
      label: t('Tecnica'),
      value: status?.tecnica?.nome,
      onClick: onTecnicaEdit,
    },
    {
      key: 'articolo',
      label: t('Colore principale'),
      value: status?.articoloPrincipale?.colore?.nome,
      onClick: onArticoloPrincipaleEdit,
    },
  ]

  return (
    <div className={cn(styles.root, className)}>
      <div className={styles.details}>
        {details.map((d) => (
          <div key={d.key} className={styles.detailsItem}>
            <span className={styles.detailsItemLabel}>{d.label}: </span>
            {!!d.onClick && !previewMode ? (
              <button
                type="button"
                onClick={d.onClick}
                disabled={previewMode}
                className={styles.detailsItemValue}
              >
                {d.value}
              </button>
            ) : (
              <span className={styles.detailsItemValue}>{d.value}</span>
            )}
            {!!d.onClick && !previewMode && (
              <button
                type="button"
                onClick={d.onClick}
                disabled={previewMode}
                className={styles.detailsItemEdit}
              >
                <Edit />
              </button>
            )}
          </div>
        ))}
      </div>
      <div className={styles.tabs}>
        {status?.posizioni?.map((p) => (
          <div key={p.configurazione.posizione.id} className={styles.position}>
            <button
              type="button"
              disabled={p.configurazione.posizione.id === posizioneId}
              className={styles.positionTrigger}
              onClick={() => setPosizioneId(p.configurazione.posizione.id)}
            >
              {p.configurazione.posizione.nome}
            </button>
            {!previewMode && (
              <button
                type="button"
                disabled={previewMode || !onPosizioneRemove}
                className={styles.positionClose}
                onClick={
                  onPosizioneRemove
                    ? () => onPosizioneRemove(p.configurazione.posizione.id)
                    : undefined
                }
              >
                <Bin />
              </button>
            )}
          </div>
        ))}
        {!!onPosizioneAdd && !previewMode && (
          <Button
            label={t('Aggiungi posizione')}
            variant="ghost"
            icon={<Plus />}
            icon_pos="right"
            disabled={previewMode}
            onClick={onPosizioneAdd}
            className={styles.addCta}
          />
        )}
      </div>
      {!!onCloseEditor && (
        <div className={styles.ctaBox}>
          <Button
            label={t('Chiudi editor')}
            variant="ghost"
            icon={<ArrowLeft />}
            icon_pos="left"
            disabled={previewMode}
            onClick={onCloseEditor}
            className={styles.closeCta}
          />
        </div>
      )}
    </div>
  )
}

export default EditorHead
